import QuoteFlowForm from './Code';

document.addEventListener("DOMContentLoaded", function(event) {
  window.podsQuoteFlow = new PodsQuoteFlow;
});

class PodsQuoteFlow {
  constructor(){
    const quoteFlowForm = new QuoteFlowForm;
  }
}